import { getApiActionTypesValues } from '../redux_utils';

export const fetchResidentLeases =
  ({ includeAllResidents } = { includeAllResidents: false }) =>
  (dispatch) =>
    dispatch({
      types: getApiActionTypesValues('FETCH_LEASES'),
      promise: ({ client }) =>
        client.get(
          `/residents/summary?includeAllResidents=${includeAllResidents}`,
        ),
      auth: true,
      redirectToHomeOnHide: true,
    });

export const fetchResidentBookmarks = () => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('FETCH_BOOKMARKS'),
    promise: ({ client }) =>
      client.get('/residents/tours-apps?includeInactiveApplications=true'),
    auth: true,
  });

export const updateCancelResidentBookmarkById = (id) => async (dispatch) => {
  await dispatch({
    promise: ({ client }) => client.put(`/residents/tours/${id}/cancel`),
    auth: true,
  });

  await dispatch(fetchResidentBookmarks());
};

export const cancelPrivateTour = (tourUniqueId) => ({
  promise: ({ client }) =>
    client.put(`/tours/cancel/private-tour/${tourUniqueId}`),
  auth: true,
});

// self tour

export const cancelSelfTour = (tourUniqueId) => ({
  promise: ({ client }) =>
    client.put(`/residents/tours/self-tour/${tourUniqueId}/cancel`),
  auth: true,
});

export const fetchCurrentUnitWithLeaseId = (unitId, leaseId) => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('FETCH_CURRENT_UNIT_WITH_LEASE'),
    promise: ({ client }) =>
      client.get(`/residents/units/${unitId}?leaseId=${leaseId}`),
    auth: true,
    redirectToHomeOnHide: true,
  });

export const fetchFavoriteHomes = () => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('FETCH_FAVORITE_HOMES'),
    promise: ({ client }) => client.get(`/residents/favorites`),
    auth: true,
  });

export const fetchFavoriteAccountsHomes = () => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('FETCH_FAVORITE_ACCOUNT_HOMES'),
    promise: ({ client }) => client.get(`/residents/favorites`),
    auth: true,
  });

export const fetchResidentFlows = () => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('FETCH_RESIDENT_FLOWS'),
    promise: ({ client }) => client.get(`/residents/flows`),
    auth: true,
  });

export const fetchResidentOccupiedTours = (leaseUniqueId) => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('FETCH_RESIDENT_OCCUPIED_TOURS'),
    promise: ({ client }) =>
      client.get(`/residents/tours/occupied/${leaseUniqueId}`),
    auth: true,
  });

export const cancelResidentOccupiedTours = (tourUniqueId) => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('CANCEL_RESIDENT_OCCUPIED_TOURS'),
    promise: ({ client }) =>
      client.put(`/residents/tours/${tourUniqueId}/cancel-occupied`),
    auth: true,
  });

export const fetchTourRequests = () => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('FETCH_TOUR_REQUESTS'),
    promise: async ({ client }) => {
      const tourRequests = await client.get(`/tour-requests`);

      const tourRequestsWithHomeDetails = await Promise.all(
        tourRequests.map(async (tourRequest) => ({
          homeDetails: await client.get(`/homes/${tourRequest.homeUniqueId}`),
          ...tourRequest,
        })),
      );

      return tourRequestsWithHomeDetails;
    },
    auth: true,
  });

export const fetchListingApplicationDetail =
  (listingApplicationId) => (dispatch) =>
    dispatch({
      types: getApiActionTypesValues('FETCH_LISTING_APPLICATION_DETAIL'),
      promise: ({ client }) => {
        return client.get(`/listing-application/${listingApplicationId}`);
      },
      auth: true,
    });

export const fetchUserProfiles = (userIds) => (dispatch) =>
  dispatch({
    types: getApiActionTypesValues('FETCH_USER_PROFILES'),
    promise: ({ client }) => {
      const query = userIds
        .map((id) => `userIds=${encodeURIComponent(id)}`)
        .join('&');
      return client.get(`/users/profiles?${query}`);
    },
    auth: true,
  });

export const updateUtilitySetup =
  (leaseUniqueId, utilityType) => async (dispatch) => {
    await dispatch({
      promise: ({ client }) =>
        client.put(`/residents/leases/${leaseUniqueId}/setup-utilities`, {
          utilityType,
          hasResidentSetup: true,
        }),
      auth: true,
    });

    await dispatch(fetchResidentLeases({ includeAllResidents: true }));
  };

export const fetchLeaseAdvisor =
  (sourceType, sourceId, assignmentType) => (dispatch) =>
    dispatch({
      types: getApiActionTypesValues('FETCH_LEASE_ADVISOR'),
      promise: ({ client }) => {
        return client.get(
          `/employees/assignments/${sourceType}/${sourceId}/${assignmentType}/active`,
        );
      },
      auth: true,
      sourceType,
      sourceId,
      assignmentType,
    });
